import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@glu/theming';
import locale from '@glu/locale';
import { Dropdown, defaultStrings_en_US as defaultStrings } from '@glu/dropdown-react';
import MobileGridContext from '../logic/MobileGridContext';
import * as actions from '../logic/actions';

const useStyles = createUseStyles(() => ({
  container: {
    display: 'flex',
    '& > *': {
      minWidth: '250px'
    }
  },
  marginRight: {
    marginRight: '15px'
  },
  fullWidth: {
    position: 'relative',
    width: '100%',
    '& > label': {
      width: '100%',
      // Get the danged dropdown to be above inputs
      '& + div': {
        zIndex: '99'
      }
    }
  }
}));

// Sort array of options base on alphanumeric / english
const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });

const MultiSelect = ({ column }) => {
  locale.set(defaultStrings);
  const classes = useStyles();
  const gridContext = React.useContext(MobileGridContext);
  const { field, headerName } = column;
  const getValue = column.filterValueGetter ? column.filterValueGetter : ({ data }) => data[field];
  // Show selection of unique choices that exist in data
  const optionsHash = {};
  for (let index = 0; index < gridContext.totalData.length; index += 1) {
    const option = gridContext.totalData[index];
    const value = getValue({ data: option });
    if (!optionsHash[value]) {
      optionsHash[value] = {
        id: value,
        name: value,
        criteriaDisplay: value
      };
    }
  }
  const unAppliedFilterState = gridContext.unAppliedFilterState || [];
  const filterValues = unAppliedFilterState.filter((filter) => filter.field === field);
  // Add options that exist in filterValues (which may or may not be in data)
  for (let index = 0; index < filterValues.length; index += 1) {
    const filterValueOption = filterValues[index];
    const filterValueOptionKey = filterValueOption?.filterData?.filter;
    if (!optionsHash[filterValueOption?.filterData?.filter]) {
      optionsHash[filterValueOptionKey] = {
        id: filterValueOptionKey,
        name: filterValueOptionKey,
        criteriaDisplay: filterValueOptionKey
      };
    }
  }
  const options = Object.values(optionsHash).sort((a, b) => collator.compare(a.name, b.name));

  const selectedDropdownValues = filterValues.map((filterValue) => ({
    id: filterValue?.filterData?.filter,
    name: filterValue?.filterData?.filter,
    criteriaDisplay: filterValue?.filterData?.filter
  }));

  return (
    <div className={classes.container}>
      <Dropdown
        className={`${classes.fullWidth} ${classes.marginRight}`}
        options={options}
        showBadges
        showTooltip
        selectedOptions={selectedDropdownValues}
        multiselect
        onChange={(_name, value) => {
          actions.updateUnappliedFilters({
            gridContext,
            payload: {
              name: field,
              value: value.map((selectedItem) => ({
                field,
                nameDisplay: headerName,
                criteriaDisplay: selectedItem.criteriaDisplay,
                id: `${field}-multi-${selectedItem.criteriaDisplay}`,
                operator: 'OR',
                filterData: {
                  type: 'contains',
                  filter: selectedItem.id,
                  filterType: 'text'
                }
              }))
            }
          });
        }}
      />
    </div>
  );
};

// {
//   field: 'status',
//   nameDisplay: 'Status',
//   criteriaDisplay: 'Requires My Approval',
//   id: 'status-multi-Requires my Approval',
//   operator: 'OR',
//   filterData: {
//     type: 'contains',
//     filter: 'Requires my approval',
//     filterType: 'text',
//   },
// },
// {
//   field: 'status',
//   nameDisplay: 'Status',
//   criteriaDisplay: 'Requires my approval Reversal',
//   id: 'status-multi-Requires my approval Reversal',
//   operator: 'OR',
//   filterData: {
//     type: 'contains',
//     filter: 'Requires my approval Reversal',
//     filterType: 'text',
//   },
// },

MultiSelect.propTypes = {
  column: PropTypes.shape({
    field: PropTypes.string,
    headerName: PropTypes.string,
    filterValueGetter: PropTypes.func
  }).isRequired
};

export default MultiSelect;
